// ValouBadges - Zeigt mehrere Valou-Badges fuer einen Ort

import React from 'react';
import type { ValouAreaId } from '../../types/valou';
import { ValouBadge } from './ValouBadge';

interface ValouBadgesProps {
  areas: ValouAreaId[];
  maxDisplay?: number;
  size?: 'xs' | 'sm';
  showLabels?: boolean;
  className?: string;
}

export function ValouBadges({
  areas,
  maxDisplay = 3,
  size = 'xs',
  showLabels = true,
  className = '',
}: ValouBadgesProps) {
  if (!areas || areas.length === 0) {
    return null;
  }

  const displayAreas = areas.slice(0, maxDisplay);
  const remaining = areas.length - maxDisplay;

  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`}>
      {displayAreas.map((areaId) => (
        <ValouBadge key={areaId} areaId={areaId} size={size} showLabel={showLabels} />
      ))}
      {remaining > 0 && (
        <span
          className={`
            inline-flex items-center rounded-full bg-gray-100 text-gray-600 font-medium
            ${size === 'xs' ? 'text-xs px-1.5 py-0.5' : 'text-xs px-2 py-1'}
          `}
        >
          +{remaining}
        </span>
      )}
    </div>
  );
}

export default ValouBadges;
